import React, { useState, useEffect, useContext } from "react";
import HospitalAddBody from "../components/DataList/HospitalAddBody";
import HospitalEditTitle from "../components/DataList/HospitalEditTitle";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Logger from "../libraries/Logger";
import { AuthContext } from "../contexts/AuthContext";
import apiClient from "../libraries/ApiClient";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 95%;
  max-height: calc(100% - 50px);
`;

function HospitalEdit({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const location = useLocation();
  const [sendHospitalData, setSendHospitalData] = useState(null);
  const [token, setToken] = useState("");
  const [rowId, setRowId] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setRowId(params.get("rowId"));
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    setToken(token);
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;

    if (token === undefined) {
      navigate("/Login");
    }
    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, [location]);

  return (
    <Container>
      <HospitalEditTitle
        Mode="Edit"
        rowId={rowId}
        sendHospitalData={sendHospitalData}
      />
      <HospitalAddBody
        Mode="Edit"
        rowId={rowId}
        setSendHospitalData={setSendHospitalData}
      />
    </Container>
  );
}

export default HospitalEdit;
